import {
  STANDARD_NUMBER_WIDTH,
  STANDARD_NUMBER_HEIGHT,
  LARGE_NUMBER_HEIGHT,
  LARGE_NUMBER_WIDTH,
} from '@Animation/constants'
import { LIGHT_THREE_ATLAS_FRAMES, LIGHT_THREE_TEXTURE_KEYS } from './constants'

export const LightThreeTexturePreloader = (scene: Phaser.Scene) => {
  if (!scene.textures.getTextureKeys().includes(LIGHT_THREE_TEXTURE_KEYS.NUMBER_DEFAULT)) {
    scene.textures.addSpriteSheetFromAtlas(LIGHT_THREE_TEXTURE_KEYS.NUMBER_DEFAULT, {
      atlas: LIGHT_THREE_TEXTURE_KEYS.ATLAS,
      frame: LIGHT_THREE_ATLAS_FRAMES.NUMBER_DEFAULT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(LIGHT_THREE_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(LIGHT_THREE_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED, {
      atlas: LIGHT_THREE_TEXTURE_KEYS.ATLAS,
      frame: LIGHT_THREE_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(LIGHT_THREE_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(LIGHT_THREE_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED, {
      atlas: LIGHT_THREE_TEXTURE_KEYS.ATLAS,
      frame: LIGHT_THREE_ATLAS_FRAMES.NUMBER_PLAYER_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(LIGHT_THREE_TEXTURE_KEYS.NUMBER_HIT)) {
    scene.textures.addSpriteSheetFromAtlas(LIGHT_THREE_TEXTURE_KEYS.NUMBER_HIT, {
      atlas: LIGHT_THREE_TEXTURE_KEYS.ATLAS,
      frame: LIGHT_THREE_ATLAS_FRAMES.NUMBER_HIT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(LIGHT_THREE_TEXTURE_KEYS.NUMBER_HIT_TRANSITION)) {
    scene.textures.addSpriteSheetFromAtlas(LIGHT_THREE_TEXTURE_KEYS.NUMBER_HIT_TRANSITION, {
      atlas: LIGHT_THREE_TEXTURE_KEYS.ATLAS,
      frame: LIGHT_THREE_ATLAS_FRAMES.NUMBER_HIT_TRANSITION,
      frameWidth: LARGE_NUMBER_WIDTH,
      frameHeight: LARGE_NUMBER_HEIGHT,
    })
  }

  if (
    !scene.textures
      .getTextureKeys()
      .includes(LIGHT_THREE_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION)
  ) {
    scene.textures.addSpriteSheetFromAtlas(
      LIGHT_THREE_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION,
      {
        atlas: LIGHT_THREE_TEXTURE_KEYS.ATLAS,
        frame: LIGHT_THREE_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED_TRANSITION,
        frameWidth: LARGE_NUMBER_WIDTH,
        frameHeight: LARGE_NUMBER_HEIGHT,
      },
    )
  }
}
